<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-pagos-agrupados"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="rowData"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :pinnedBottomRowData="pinnedBottomRowData">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ListadoSolicitudesPagosAgregados',
  mixins: [listadoAgGridMixin],
  computed: {
    rowData() {
      const rowData = [];

      this.items?.forEach((item) => {
        item?.detallesSolicitudesPagos?.forEach((detalle) => {
          rowData.push({
            ...item,
            ...detalle,
          });
        });
      });

      return rowData;
    },
    pinnedBottomRowData() {
      return [
        {
          numeroCuota: 'Total',
          detallePlanPagoConceptoUniversidad: {
            monto: formatearValorAMoneda(
              this.rowData.reduce((acc, item) => acc + Number(item.detallePlanPagoConceptoUniversidad.monto), 0),
            ),
          },
        },
      ];
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'CONCEPTO',
          field: 'detallePlanPagoConceptoUniversidad.planPagoConceptoUniversidad.conceptoUniversidad.concepto.nombre',
          filter: true,
          minWidth: 200,
        },
        {
          headerName: 'N° CUOTA',
          field: 'numeroCuota',
          filter: true,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MONTO',
          field: 'detallePlanPagoConceptoUniversidad.monto',
          filter: true,
          valueFormatter: this.formatearValorAMoneda,
          type: 'numericColumn',
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'PROGRAMA UNIVERSIDAD',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            const programaUniversidad = params.data.programaUniversidad;

            return `${programaUniversidad?.codigo} - ${programaUniversidad.programaNombre}`;
          },
          field: 'programaUniversidad.programaNombre',
          filter: true,
          minWidth: 450,
        },
        {
          headerName: 'N° DOCUMENTO',
          field: 'inscripcionProgramaUniversidad.inscripcion.estudiante.numeroDocumento',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PRIMER APELLIDO',
          field: 'inscripcionProgramaUniversidad.inscripcion.estudiante.primerApellido',
          minWidth: 180,
        },
        {
          headerName: 'SEGUNDO APELLIDO',
          field: 'inscripcionProgramaUniversidad.inscripcion.estudiante.segundoApellido',
          minWidth: 180,
        },
        {
          headerName: 'NOMBRES',
          field: 'inscripcionProgramaUniversidad.inscripcion.estudiante.nombres',
          minWidth: 200,
        },
        {
          headerName: 'SEDE UNIVERSIDAD',
          field: 'programaUniversidad.sedeUniversidad.nombre',
          filter: true,
          minWidth: 200,
        },
        {
          headerName: 'PROGRAMA',
          field: 'inscripcionProgramaUniversidad.inscripcion.programa.nombreCompuesto',
          minWidth: 400,
        },
        {
          headerName: 'SEDE',
          field: 'inscripcionProgramaUniversidad.inscripcion.programa.sede.nombre',
          minWidth: 160,
          maxWidth: 160,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-pagos-agrupados {
  height: calc(var(--vh, 1vh) * 100 - 18rem);
}
</style>
  